module.exports = __webpack_public_path__ + "img/reserved_selected.3b300866.svg";